/**
 * API Configuration
 * Centralized configuration for API endpoints and settings
 */

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_UNRELEASED_BACKEND_URL || window.location.origin,
  WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL || 
    // Fallback: derive from BASE_URL if not set
    (process.env.REACT_APP_UNRELEASED_BACKEND_URL || window.location.origin).replace(/^http/, 'ws') + '/ws',
  ENDPOINTS: {
    AUTH: '/auth',
    ARTIST: '/api/Artist',
    TRACK: '/api/Track',
    FEEDBACK: '/api/Feedback',
  },
  TIMEOUTS: {
    DEFAULT: 10000, // 10 seconds
    UPLOAD: 60000,  // 60 seconds for file uploads
  },
} as const;

export const API_BASE_URL = API_CONFIG.BASE_URL;
export const WEBSOCKET_BASE_URL = API_CONFIG.WEBSOCKET_URL;